(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('matty-announcement-height')) {
    customElements.define('matty-announcement-height', class extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.shopify-section');
        this.mobile = matchMedia('(max-width:749px)');
        this.update = () => {
          const bar = this.wrapper.querySelector('.matty-announcement-bar');
          const height = this.mobile.matches && bar?.getClientRects().length ? this.wrapper.getBoundingClientRect().height : 0;
          document.documentElement.style.setProperty('--matty-announcement-height', `${height}px`);
        };
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.wrapper);
        this.mobile.addEventListener('change', this.update);
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.update);
        document.documentElement.style.removeProperty('--matty-announcement-height');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('matty-cart-count')) {
    customElements.define('matty-cart-count', class extends HTMLElement {
      connectedCallback() {
        this.previousCount = Number(this.textContent.trim());
        this.observer = new MutationObserver(() => {
          const count = Number(this.textContent.trim());
          if (count > this.previousCount && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.getAnimations().forEach(animation => animation.cancel());
            this.animate([
              { transform: 'scale(1)' },
              { transform: 'scale(1.16)' },
              { transform: 'scale(1)' }
            ], { duration: 280, easing: 'ease-out' });
          }
          this.previousCount = count;
        });
        this.observer.observe(this, { childList: true, characterData: true, subtree: true });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab-vote-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('matty-lab-popup')) {
    customElements.define('matty-lab-popup', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const events = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.template = this.querySelector('template');
        this.options = [...this.querySelectorAll('[data-lvp-choice]')];
        if (!this.dialog || !this.template) return;
        this.design = this.dataset.designMode === 'true';
        this.preview = this.dataset.previewAllowed === 'true' && new URLSearchParams(location.search).get('lab_preview') === '1';
        this.key = 'matty_lab_' + this.dataset.campaign;
        this.choice = this.read('sessionStorage', this.key + '_choice');
        if (!this.options.some(option => option.dataset.lvpChoice === this.choice)) this.choice = null;
        this.pending = this.read('sessionStorage', this.key + '_pending');
        this.screen = 'vote';
        this.opened = false;
        this.completed = false;
        this.activeSeconds = 0;
        this.busyUntil = 0;
        this.pageViews = Number(this.read('sessionStorage', this.key + '_views') || 0) + 1;
        if (!this.preview && !this.design) this.write('sessionStorage', this.key + '_views', this.pageViews);
        this.dialog.addEventListener('click', event => {
          if (event.target.closest('[data-lvp-close]')) this.dialog.close();
          if (event.target === this.dialog) {
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          }
          const option = event.target.closest('[data-lvp-choice]');
          if (option) {
            this.choice = option.dataset.lvpChoice;
            if (!this.preview && !this.design) this.write('sessionStorage', this.key + '_choice', this.choice);
            this.mountForm();
            this.syncChoice();
            this.track('select');
            this.show('capture');
          }
          if (event.target.closest('[data-lvp-change]')) {
            this.show('vote');
            this.options.find(option => option.dataset.lvpChoice === this.choice)?.focus();
            this.track('change');
          }
        }, events);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const focusable = [...this.dialog.querySelectorAll('button:not([disabled]),a[href],input:not([type="hidden"]):not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }, events);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('matty-lab-open');
          if (!this.completed) {
            if (!this.preview && !this.design) this.write('localStorage', this.key, { dismissed: Date.now() });
            this.track('dismiss');
          }
          if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
        }, events);
        document.addEventListener('input', event => {
          if (!this.contains(event.target)) this.busyUntil = Date.now() + 15000;
        }, events);
        document.addEventListener('shopify:section:select', event => {
          if (event.detail?.sectionId === this.dataset.sectionId) { this.show('vote', false); this.open(); }
        }, events);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.detail?.sectionId === this.dataset.sectionId) this.dialog.close();
        }, events);
        this.updateViewport = () => {
          const height = window.visualViewport?.height || window.innerHeight;
          this.dialog.style.setProperty('--lvp-viewport-height', Math.max(160, height - 32) + 'px');
        };
        window.visualViewport?.addEventListener('resize', this.updateViewport, events);
        this.updateViewport();
        const posted = !!this.template.content.querySelector('[data-lvp-posted]');
        const errored = !!this.template.content.querySelector('[data-lvp-errored]');
        const ownResponse = this.pending && Date.now() - this.pending.time < 3600000 && this.pending.path === location.pathname && location.hash === '#' + this.dataset.formId;
        if ((posted || errored) && ownResponse) {
          this.choice = this.options.some(option => option.dataset.lvpChoice === this.pending.choice) ? this.pending.choice : null;
          if (posted) {
            this.completed = true;
            this.write('localStorage', this.key, { subscribed: Date.now() });
            this.remove('sessionStorage', this.key + '_pending');
            this.show('success', false);
            this.track('success');
          } else {
            this.mountForm();
            this.syncChoice();
            this.show(this.choice ? 'capture' : 'vote', false);
            this.track('error');
          }
          const y = this.pending.scroll || 0;
          history.replaceState(null, '', location.pathname + location.search);
          window.scrollTo(0, y);
          this.open();
        } else if (this.preview) {
          this.show('vote', false);
          this.open();
        } else if (!posted && !errored && !this.design && !this.suppressed() && this.dataset.autoEnabled === 'true') {
          this.timer = setInterval(() => {
            if (document.hidden) return;
            this.activeSeconds++;
            const engaged = this.pageViews > 1 || window.scrollY >= Math.min(350, Math.max(120, (document.documentElement.scrollHeight - innerHeight) * .2));
            if (this.activeSeconds >= Number(this.dataset.delay || 25) && engaged && !this.busy() && !this.suppressed()) {
              this.show('vote', false);
              this.open();
            }
          }, 1000);
        }
        this.syncChoice();
      }
      read(storage, key) { try { return JSON.parse(window[storage].getItem(key)); } catch { return null; } }
      write(storage, key, value) { try { window[storage].setItem(key, JSON.stringify(value)); } catch {} }
      remove(storage, key) { try { window[storage].removeItem(key); } catch {} }
      suppressed() {
        if (this.dataset.knownSubscriber === 'true') return true;
        const state = this.read('localStorage', this.key);
        const legacy = Number(this.read('localStorage', 'lvp_seen_' + this.dataset.sectionId) || 0);
        return !!state?.subscribed || Date.now() - Math.max(state?.dismissed || 0, legacy) < Number(this.dataset.frequency || 14) * 86400000;
      }
      busy() {
        if (Date.now() < this.busyUntil || document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return true;
        if ([...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"]')].some(el => el !== this.dialog && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden')) return true;
        return [...document.querySelectorAll('video')].some(video => !video.paused && !video.muted);
      }
      mountForm() {
        if (this.form) return;
        this.querySelector('[data-lvp-form-slot]').append(this.template.content.cloneNode(true));
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', event => {
          if (!this.choice || this.design) {
            event.preventDefault();
            if (!this.choice) this.show('vote');
            return;
          }
          this.syncChoice();
          this.write('sessionStorage', this.key + '_pending', { choice: this.choice, path: location.pathname, time: Date.now(), scroll: window.scrollY });
          this.track('submit');
        }, { signal: this.controller.signal });
      }
      syncChoice() {
        const chosen = this.options.find(option => option.dataset.lvpChoice === this.choice);
        this.options.forEach(option => option.setAttribute('aria-pressed', String(option === chosen)));
        this.querySelector('[data-lvp-selected]').textContent = chosen?.dataset.name || '';
        if (this.form && chosen) this.form.querySelector('[name="contact[tags]"]').value = [this.dataset.baseTag, 'voted-' + this.choice, 'lab-campaign-' + this.dataset.campaign, 'lab-' + this.dataset.campaign + '-' + this.choice].filter(Boolean).join(', ');
      }
      show(screen, focus = true) {
        this.screen = screen;
        this.querySelectorAll('[data-lvp-screen]').forEach(el => { el.hidden = el.dataset.lvpScreen !== screen; });
        const heading = this.querySelector('[data-lvp-screen="' + screen + '"] h2');
        heading.id ||= 'Lab-' + screen + '-' + this.dataset.sectionId;
        this.dialog.setAttribute('aria-labelledby', heading.id);
        this.dialog.scrollTop = 0;
        if (focus && this.dialog.open) heading.focus({ preventScroll: true });
      }
      open() {
        clearInterval(this.timer);
        if (this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('matty-lab-open');
        this.opened = true;
        this.track('view');
      }
      track(action) {
        if (this.preview || this.design) return;
        const detail = { event: 'matty_lab_' + action, campaign: this.dataset.campaign, option: this.choice || '', step: this.screen };
        document.dispatchEvent(new CustomEvent('matty:lab', { detail }));
        if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matty-legal"]) return;
  try {
    
  function initMattyLegal(scope) {
    scope.querySelectorAll('[data-matty-legal]').forEach((root) => {
      if (root.dataset.legalReady) return;
      const body = root.querySelector('[data-legal-body]');
      const headings = Array.from(body.querySelectorAll('h2, h3'));
      const list = root.querySelector('[data-legal-links]');
      if (!headings.length) return;
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = root.querySelector('h1').id + '-section-' + (index + 1);
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent.trim();
        link.addEventListener('click', () => {
          list.querySelectorAll('a').forEach((other) => other.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'location');
          if (window.matchMedia('(max-width:899px)').matches) root.querySelector('details').open = false;
          heading.setAttribute('tabindex', '-1');
          heading.focus({preventScroll: true});
        });
        item.appendChild(link);
        list.appendChild(item);
      });
      root.querySelector('details').open = !window.matchMedia('(max-width:899px)').matches;
      root.querySelector('[data-legal-sidebar]').hidden = false;
      root.dataset.legalReady = 'true';
    });
  }
  initMattyLegal(document);
  document.addEventListener('shopify:section:load', (event) => initMattyLegal(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["matty-shop-collection"] && !Shopify.designMode) return;
  try {
    
  if (!window.mattyShopSortBound) {
    window.mattyShopSortBound = true;
    const enhance = () => document.querySelectorAll('.matty-shop__sort button').forEach(button => button.hidden = true);
    enhance();
    document.addEventListener('shopify:section:load', enhance);
    document.addEventListener('change', event => {
      if (!event.target.matches('.matty-shop__sort select')) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      window.location.assign(url);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shortform-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('matty-motion')) customElements.define('matty-motion', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.rail = this.querySelector('[data-rail]');
    this.cards = [...this.querySelectorAll('[data-card]')];
    this.dialog = this.querySelector('dialog');
    this.full = this.querySelector('[data-full-video]');
    this.reveal = this.querySelector('[data-reveal]');
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.visible = new Set();
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.intersectionRatio >= .6 ? this.visible.add(entry.target) : this.visible.delete(entry.target));
      this.sync();
    }, { threshold: [0,.6,1] });
    this.cards.forEach(card => {
      this.observer.observe(card);
      const video = card.querySelector('[data-preview]');
      if (!video) return;
      const pause = card.querySelector('[data-pause]');
      const update = () => { pause.dataset.paused = String(video.paused); pause.setAttribute('aria-label', video.paused ? pause.dataset.playLabel : pause.dataset.pauseLabel); };
      ['playing','pause'].forEach(event => video.addEventListener(event, update, options));
      update();
      card.querySelector('[data-watch]').addEventListener('click', () => this.open(card), options);
      pause.addEventListener('click', () => {
        card.dataset.userPaused = video.paused ? 'false' : 'true';
        card.dataset.userPlayed = 'true';
        if (video.paused) this.start(video); else video.pause();
      }, options);
      card.querySelector('[data-sound]').addEventListener('click', event => {
        const unmute = video.muted;
        this.cards.forEach(other => {
          const v = other.querySelector('video');
          if (v) v.muted = true;
          other.querySelector('[data-sound]')?.setAttribute('aria-pressed','false');
        });
        video.muted = !unmute;
        event.currentTarget.setAttribute('aria-pressed', String(unmute));
        if (unmute) { card.dataset.userPlayed='true'; card.dataset.userPaused='false'; this.start(video); }
      }, options);
    });
    this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
    this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
    this.rail.addEventListener('scroll', () => this.navigation(), { ...options, passive:true });
    this.rail.addEventListener('keydown', event => {
      if (event.target !== this.rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
    }, options);
    window.addEventListener('resize', () => this.navigation(), options);
    document.addEventListener('visibilitychange', () => this.sync(), options);
    this.motion.addEventListener('change', () => this.sync(), options);
    this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), options);
    this.dialog.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const r=this.dialog.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) this.dialog.close();
    }, options);
    this.dialog.addEventListener('close', () => {
      this.full.pause(); this.full.removeAttribute('src'); this.full.load();
      document.documentElement.classList.remove('matty-motion-open');
      this.sync(); this.opener?.focus({preventScroll:true});
    }, options);
    this.reveal.addEventListener('click', () => { this.showControls(); this.full.focus({preventScroll:true}); }, options);
    ['pause','ended','error'].forEach(event => this.full.addEventListener(event, () => { if(this.dialog.open) this.showControls(); }, options));
    this.navigation();
  }
  start(video) {
    if (!video.getAttribute('src')) { video.src=video.dataset.src; video.preload='auto'; }
    video.play()?.catch(() => {});
  }
  sync() {
    this.cards.forEach(card => {
      const video=card.querySelector('video'); if(!video) return;
      if(this.visible.has(card)&&!document.hidden&&!this.dialog.open&&card.dataset.userPaused!=='true'&&(!this.motion.matches||card.dataset.userPlayed==='true')) this.start(video);
      else video.pause();
    });
  }
  move(direction) {
    const step=(this.cards[0]?.getBoundingClientRect().width||0)+parseFloat(getComputedStyle(this.rail).gap);
    this.rail.scrollBy({left:direction*step,behavior:this.motion.matches?'instant':'smooth'});
  }
  navigation() {
    this.querySelector('[data-prev]').disabled=this.rail.scrollLeft<2;
    this.querySelector('[data-next]').disabled=this.rail.scrollLeft+this.rail.clientWidth>=this.rail.scrollWidth-2;
  }
  showControls() { this.full.controls=true; this.full.tabIndex=0; this.reveal.hidden=true; }
  open(card) {
    this.opener=card.querySelector('[data-watch]');
    this.querySelector('[data-modal-title]').textContent=card.querySelector('[data-title]').textContent;
    const link=card.querySelector('[data-product-link]');
    this.querySelector('[data-modal-footer]').replaceChildren(...(link?[link.cloneNode(true)]:[]));
    this.full.controls=false; this.full.removeAttribute('tabindex'); this.reveal.hidden=false;
    this.full.poster=card.querySelector('video').poster;
    this.full.src=card.querySelector('video').dataset.fullSrc;
    this.full.muted=false; this.full.preload='auto'; this.full.load();
    this.dialog.showModal(); document.documentElement.classList.add('matty-motion-open');
    this.sync();
    this.full.play()?.catch(() => { if(this.dialog.open) { this.full.pause(); this.showControls(); } });
  }
  disconnectedCallback() {
    this.observer?.disconnect(); this.abort?.abort();
    this.cards?.forEach(card=>card.querySelector('video')?.pause());
    this.full?.pause();
    if(this.dialog?.open) { this.dialog.close(); document.documentElement.classList.remove('matty-motion-open'); }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories-from-brand"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('matty-studio')) customElements.define('matty-studio', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort=new AbortController();
    const options={signal:this.abort.signal};
    this.rail=this.querySelector('[data-rail]'); this.dialog=this.querySelector('dialog'); this.player=this.querySelector('[data-player]');
    this.previous=this.querySelector('[data-previous]'); this.next=this.querySelector('[data-next]');
    this.previous.addEventListener('click',()=>this.move(-1),options); this.next.addEventListener('click',()=>this.move(1),options);
    this.rail.addEventListener('scroll',()=>this.update(),{...options,passive:true});
    this.rail.addEventListener('keydown',event=>{
      if(event.target!==this.rail||!['ArrowLeft','ArrowRight'].includes(event.key)) return;
      event.preventDefault(); this.move(event.key==='ArrowRight'?1:-1);
    },options);
    this.resize?.disconnect(); this.resize=new ResizeObserver(()=>this.update()); this.resize.observe(this.rail);
    this.querySelectorAll('[data-watch]').forEach(link=>link.addEventListener('click',event=>{
      if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
      const embed=this.embedURL(link.href); if(!embed) return;
      event.preventDefault(); this.opener=link;
      this.querySelector('[data-dialog-title]').textContent=link.dataset.title;
      this.querySelector('[data-external]').href=link.href;
      const frame=document.createElement('iframe'); frame.title=link.dataset.title;
      frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen'; frame.allowFullscreen=true;
      frame.referrerPolicy='strict-origin-when-cross-origin'; frame.src=embed;
      this.player.replaceChildren(frame); this.dialog.showModal(); document.documentElement.classList.add('matty-studio-open');
    },options));
    this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),options);
    this.dialog.addEventListener('click',event=>{
      if(event.target!==this.dialog) return;
      const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) this.dialog.close();
    },options);
    this.dialog.addEventListener('close',()=>{
      this.player.replaceChildren(); document.documentElement.classList.remove('matty-studio-open'); this.opener?.focus({preventScroll:true});
    },options);
    this.update();
  }
  embedURL(value) {
    try {
      const u=new URL(value); if(u.protocol!=='https:') return null;
      let id;
      if(u.hostname==='youtu.be') id=u.pathname.slice(1);
      else if(['youtube.com','www.youtube.com','m.youtube.com'].includes(u.hostname)) {
        id=u.pathname==='/watch'?u.searchParams.get('v'):u.pathname.match(/^\/(?:embed|shorts)\/([^/]+)$/)?.[1];
      }
      if(!id||!/^[-\w]{11}$/.test(id)) return null;
      const result=new URL('https://www.youtube-nocookie.com/embed/'+id);
      result.searchParams.set('autoplay','1'); result.searchParams.set('playsinline','1'); result.searchParams.set('rel','0');
      const time=u.searchParams.get('t')||u.searchParams.get('start')||'';
      const m=time.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
      const seconds=/^\d+$/.test(time)?Number(time):m?Number(m[1]||0)*3600+Number(m[2]||0)*60+Number(m[3]||0):0;
      if(seconds>0) result.searchParams.set('start',String(seconds));
      return result.href;
    } catch { return null; }
  }
  move(direction) {
    const card=this.rail.querySelector('.studio__card'); if(!card) return;
    const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.rail).gap);
    this.rail.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  }
  update() { this.previous.disabled=this.rail.scrollLeft<2; this.next.disabled=this.rail.scrollLeft+this.rail.clientWidth>=this.rail.scrollWidth-2; }
  disconnectedCallback() {
    this.abort?.abort(); this.resize?.disconnect(); this.player?.replaceChildren();
    if(this.dialog?.open) { this.dialog.close(); document.documentElement.classList.remove('matty-studio-open'); }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-portal"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.ws-portal');
    sections.forEach(initSection);

    function initSection(root) {
      var sectionId = root.dataset.sectionId;
      var STORAGE_KEY = 'ws-portal-unlocked-' + sectionId;

      var gate = root.querySelector('[data-ws-gate]');
      var content = root.querySelector('[data-ws-content]');
      var unlockBtn = root.querySelector('[data-ws-unlock]');
      var passInput = root.querySelector('[data-ws-password]');
      var errorEl = root.querySelector('[data-ws-error]');

      // Get access code from inline data attribute (passed via Liquid)
      // We'll use a small script tag below to set this
      var accessCode = root.dataset.accessCode || '';

      // If gate enabled, check session
      if (gate) {
        var unlocked = sessionStorage.getItem(STORAGE_KEY) === 'yes';
        if (unlocked) {
          showContent();
        }

        if (unlockBtn) {
          unlockBtn.addEventListener('click', tryUnlock);
        }
        if (passInput) {
          passInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              tryUnlock();
            }
          });
        }
      }

      function tryUnlock() {
        if (!passInput || !accessCode) return;
        var entered = (passInput.value || '').trim().toUpperCase();
        var expected = accessCode.toUpperCase();
        if (entered === expected) {
          sessionStorage.setItem(STORAGE_KEY, 'yes');
          showContent();
        } else {
          if (errorEl) errorEl.textContent = 'Invalid access code · Try again';
          passInput.value = '';
          passInput.focus();
        }
      }

      function showContent() {
        if (gate) gate.style.display = 'none';
        if (content) content.style.display = 'block';
      }

      // Order calc
      var qtyInputs = root.querySelectorAll('.ws-qty');
      var msrpTotalEl = root.querySelector('[data-ws-msrp-total]');
      var discountTotalEl = root.querySelector('[data-ws-discount-total]');
      var unitTotalEl = root.querySelector('[data-ws-unit-total]');
      var grandTotalEl = root.querySelector('[data-ws-grand-total]');

      function money(n) {
        return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      function recalc() {
        var msrpTotal = 0;
        var wholesaleTotal = 0;
        var unitTotal = 0;

        qtyInputs.forEach(function(input) {
          var qty = parseInt(input.value, 10);
          if (isNaN(qty) || qty < 0) qty = 0;

          var msrp = parseFloat(input.dataset.msrp);
          if (isNaN(msrp)) msrp = 0;

          var wholesale = parseFloat(input.dataset.wholesale);
          if (isNaN(wholesale)) wholesale = 0;

          var lineTotal = qty * wholesale;

          // Find the line-total cell in the same row
          var row = input.closest('.ws-row');
          var lineCell = row ? row.querySelector('.ws-line-total') : null;
          if (lineCell) {
            lineCell.textContent = money(lineTotal);
            lineCell.classList.toggle('zero', qty === 0);
          }

          msrpTotal += qty * msrp;
          wholesaleTotal += lineTotal;
          unitTotal += qty;
        });

        if (msrpTotalEl) msrpTotalEl.textContent = money(msrpTotal);
        if (discountTotalEl) discountTotalEl.textContent = '−' + money(msrpTotal - wholesaleTotal);
        if (unitTotalEl) unitTotalEl.textContent = unitTotal.toLocaleString();
        if (grandTotalEl) grandTotalEl.textContent = money(wholesaleTotal);
      }

      qtyInputs.forEach(function(input) {
        input.addEventListener('input', recalc);
      });

      // Stepper button handlers
      var stepBtns = root.querySelectorAll('[data-ws-step]');
      stepBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var stepper = btn.closest('.ws-stepper');
          if (!stepper) return;
          var input = stepper.querySelector('.ws-qty');
          if (!input || input.disabled) return;

          var direction = parseInt(btn.dataset.wsStep, 10);
          var step = parseInt(input.step, 10) || 1;
          var current = parseInt(input.value, 10);
          if (isNaN(current)) current = 0;

          var newValue = current + (direction * step);
          if (newValue < 0) newValue = 0;
          input.value = newValue;
          recalc();
        });
      });

      var resetBtn = root.querySelector('[data-ws-reset]');
      if (resetBtn) {
        resetBtn.addEventListener('click', function() {
          qtyInputs.forEach(function(i) { i.value = 0; });
          recalc();
        });
      }

      recalc();

      // Form submission — Shopify native, just populate the hidden body field
      var form = root.querySelector('.ws-form');
      var submitBtn = root.querySelector('[data-ws-submit]');
      var bodyField = root.querySelector('[data-ws-body-field]');

      function buildOrderBody() {
        var lines = [];
        var msrpTotal = 0;
        var wholesaleTotal = 0;
        var unitTotal = 0;
        var orderLines = [];

        qtyInputs.forEach(function(input) {
          var qty = parseInt(input.value, 10) || 0;
          if (qty === 0) return;
          var msrp = parseFloat(input.dataset.msrp) || 0;
          var wholesale = parseFloat(input.dataset.wholesale) || 0;
          var name = input.dataset.name || '';
          var num = input.dataset.num || '';
          var lineTotal = qty * wholesale;
          msrpTotal += qty * msrp;
          wholesaleTotal += lineTotal;
          unitTotal += qty;
          orderLines.push('  • № ' + num + ' — ' + name);
          orderLines.push('    Qty: ' + qty + ' × ' + money(wholesale) + ' = ' + money(lineTotal));
        });

        lines.push('═══ WHOLESALE ORDER ═══');
        lines.push('');
        lines.push('LINE ITEMS:');
        lines.push.apply(lines, orderLines);
        lines.push('');
        lines.push('────────────────────');
        lines.push('Subtotal (MSRP): ' + money(msrpTotal));
        lines.push('Wholesale Discount: −' + money(msrpTotal - wholesaleTotal));
        lines.push('Total Units: ' + unitTotal);
        lines.push('WHOLESALE TOTAL: ' + money(wholesaleTotal));
        lines.push('────────────────────');

        return lines.join('\n');
      }

      if (form) {
        form.addEventListener('submit', function(e) {
          var unitTotal = 0;
          qtyInputs.forEach(function(input) {
            unitTotal += parseInt(input.value, 10) || 0;
          });

          if (unitTotal === 0) {
            e.preventDefault();
            alert('Please add at least one item to your order.');
            return;
          }

          // Populate hidden body field with the full formatted order summary
          if (bodyField) {
            bodyField.value = buildOrderBody();
          }

          // Let Shopify handle the rest natively
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Submitting...';
          }
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
